import script from "./SideMenu.vue?vue&type=script&lang=jsx"
export * from "./SideMenu.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__